import * as React from 'react';
import { shuffle } from 'lodash';

export const INVESTOR_WHEEL_TEXT = '{{investor_wheel}}';

const NAMES = ['Snowflake', 'Databricks', 'BigQuery'];

/*
"it literally came up at the series b where the snowflake vp was mad
databricks was listed first and i was like “oh refresh” and it changed
and he thought we “fixed” it lol" -- Barry
*/

interface InvestorWheelProps {
  text: string;
}

export const InvestorWheel: React.ComponentType<InvestorWheelProps> =
  React.memo(({ text }) => {
    const randomOrder = shuffle(NAMES);
    const orderAsString = `${randomOrder[0]}, ${randomOrder[1]}, and ${randomOrder[2]}`;
    const replacedText = text.replace(INVESTOR_WHEEL_TEXT, orderAsString);

    return <>{replacedText}</>;
  });
